<template>
  <v-container fluid>
    <v-row>
      <v-col cols="6" class="py-0">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn color="tertiary" @click="showDialog" class="mr-3">Gebruiker toevoegen</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" class="px-0">
        <v-card class="pa-5" tile>
          <v-data-table
            class="clickable"
            :headers="headers"
            :loading="loading"
            :items="items"
            sort-by="first_name"
            :options.sync="options"
            :items-per-page-items="itemsPerPageItems"
            :server-items-length="totalItems"
            @click:row="showDialog"
          >

            <template v-slot:top>
              <v-row no-gutters>
                <v-spacer></v-spacer>
                <v-col cols="4">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-folder-search"
                    label="Zoeken"
                    single-line
                    hide-details
                    class="ml-3"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>

            <template v-slot:item.status="{ value }">
              <v-icon :color="value ? 'green' : 'grey'">mdi-circle-medium</v-icon>
            </template>

            <template v-slot:item.is_admin="{ value }">
              <v-icon :color="value ? 'green' : 'grey'">mdi-circle-medium</v-icon>
            </template>

            <template v-slot:no-data>
              <span>Geen data beschikbaar.</span>
            </template>

          </v-data-table>

          <ItemDialog ref="itemDialog" @update="fetchItems" />

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'
import SessionService from '@/services/session.service'
import ItemDialog from '@/components/UserDialog'
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    ItemDialog,
  },
  data: () => ({
    headers: [
      { text: 'Gebruikersnaam', value: 'username', align: 'left', sortable: false, width: '15%' },
      { text: 'Naam', value: 'full_name', align: 'left', sortable: false, width: '15%' },
      { text: 'Email', value: 'email', align: 'left', sortable: false, width: '15%' },
      { text: 'Telefoon', value: 'phone_number', align: 'left', sortable: false, width: '15%' },
      { text: 'Bedrijf', value: 'company_name', align: 'left', sortable: false, width: '15%' },
      { text: 'Beheerder', value: 'is_admin', align: 'center', sortable: false, width: '15%' },
      { text: 'Status', value: 'status', align: 'center', sortable: false, width: '10%' },
    ],

    items: [],
    totalItems: 0,
    loading: true,
    options: { itemsPerPage: 10 },
    search: null,

    itemsPerPageItems: [5, 10, 25, 50],
  }),
  computed: {
    ...mapState('auth', {
      availableRoles: state => state.roles,
    }),
  },
  watch: {
    options: {
      handler () {
        this.fetchItems()
      },
      deep: true
    },
    search() {
      this.fetchItems()
    },
  },
  created() {
    this.restoreFilters()
    
    this.breadcrumbs = [
      {
        text: 'Gebruikers',
        disabled: true,
      },
    ]
  },
  methods: {
    showDialog(item = null) {
      this.$refs.itemDialog.showDialog(item ? item.id : null)
    },
    fetchItems: _.debounce(function() {
      this.loading = true
      this.saveFilters()
      ApiService.index('/users', this.options, {
        params: {
          //expand: 'roles',
          filter: {
            query: this.search,
            //status: this.userStatus,
          },
        },
      }).then(({ items, total })  => {
        this.items = items
        this.totalItems = total
        this.loading = false
      }).catch(() => {
        this.loading = 'error'
      })
    }, 250),
    saveFilters() {
      SessionService.setItem('filter_users', {
        search: this.search,
        options: this.options,
      })
    },
    restoreFilters() {
      let filters = SessionService.getItem('filter_users')
      if (filters) {
        this.search = filters.search
        this.options = filters.options
      }
    },
  }

}
</script>

<style scoped>

::v-deep .v-data-table table tbody tr:not(.v-data-table__empty-wrapper):hover {
  cursor: pointer;
}

</style>